import { DBACTIONVARTYPES, TpDashboardActionContext } from '../interfaces';

export function createDbActionVar_Value(ctx: TpDashboardActionContext, name: string, content: any) {
  ctx.variables[name] = {
    type: DBACTIONVARTYPES.Value,
    content,
  };
}
